<!--  -->
<template>
  <div>
    <van-popup
      class="popup"
      v-model="haibaoShow"
      :round="true"
      @click-overlay="haibaoclose"
      :close-on-click-overlay="false"
    >
      <div class="loading" v-show="!imgUrl">
        <van-loading  size="24px" vertical>图片生成中...</van-loading>
      </div>

      <div class="sharePage" ref="imageWrapper" id="imageWrapper" v-show="!imgUrl">
        <div class="zhanwei">
          <div class="weekBg">
            <img
              crossorigin="anonymous"
              src="@/assets/img/weekReport/weekreportbg.png?v=3"
              alt=""
            />
            <p class="time">{{ startTime }}-{{ endTime }}</p>
          </div>
        </div>
        <TitleInfo :duoyushow="true" v-show="gaikuang" :titleInfo="titleInfo" />
        <AnswerVolumeHaibao
          v-show="datiliang"
          :answerTitinfo="answerTitinfo"
          :answerData="answerData"
          :chooseList="chooseList"
        />
        <CorrectRateHaibao
          v-show="zhengquelv"
          :pingjunTitinfo="pingjunTitinfo"
          :pingjunData="pingjunData"
        />
        <ExamPointsHaibao
          v-show="kaodianfenxi"
          :fenximathTitinfo="fenximathTitinfo"
          :fenxienglishTitinfo="fenxienglishTitinfo"
          :fenximathData="fenximathData"
          :fenxienglishData="fenxienglishData"
          :chooseList="chooseList"
        />
        <div class="qihang">
          <template>
            <img
              crossorigin="anonymous"
              class="img1"
              src="@/assets/img/weekReport/shareLogo.png?v=1"
              alt=""
            />
            <img
              crossorigin="anonymous"
              class="img2"
              src="@/assets/img/weekReport/shareWhat.png?v=2"
              alt=""
            />
          </template>
        </div>
      </div>
      <div class="sharePage" v-show="imgUrl">
        <div class="posterBox">
          <img class="poster" :src="imgUrl" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 只在h5中显示 -->
    <p v-if="onlyShow" class="onlytips">长按保存分享至朋友圈/微信群</p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import html2canvas from 'html2canvas';
import TitleInfo from './components/titleInfo.vue';
import AnswerVolumeHaibao from './components/answerVolumeHaibao.vue';
import CorrectRateHaibao from './components/correctRateHaibao.vue';
import ExamPointsHaibao from './components/examPointsHaibao.vue';
import loadJS from 'load-js';

export default {
  props: {
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    titleInfo: {
      type: Object,
      default: () => {},
    },
    answerTitinfo: {
      type: Object,
      default: () => {},
    },
    pingjunTitinfo: {
      type: Object,
      default: () => {},
    },
    fenximathTitinfo: {
      type: Object,
      default: () => {},
    },
    fenxienglishTitinfo: {
      type: Object,
      default: () => {},
    },
    answerData: {
      type: Array,
      default: () => [],
    },
    pingjunData: {
      type: Array,
      default: () => [],
    },
    fenximathData: {
      type: Array,
      default: () => [],
    },
    fenxienglishData: {
      type: Array,
      default: () => [],
    },
    chooseList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TitleInfo,
    AnswerVolumeHaibao,
    CorrectRateHaibao,
    ExamPointsHaibao,
  },
  data() {
    return {
      haibaoShow: true,
      qrcode: '',
      imgUrl: null,
      gaikuang: false,
      datiliang: false,
      zhengquelv: false,
      kaodianfenxi: false,
      onlyShow: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  created() {
    if (!this.$root.miniprogram || !this.$root.$data.isApp) {
      this.onlyShow = true;
    }
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
    this.moduleCteate();
    setTimeout(() => {
      this.toImage();
    }, 1000);
  },
  methods: {
    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent',
        width: document.querySelector('#imageWrapper').scrollWidth,
        height: document.querySelector('#imageWrapper').scrollHeight,
        windowWidth: document.querySelector('#imageWrapper').scrollWidth,
        windowHeight: document.querySelector('#imageWrapper').scrollHeight,
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.imgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.imgUrl,
              title: '学习周报',
              content: '',
              icon: '',
            },
            false,
          );
        }
      });
    },

    haibaoclose() {
      this.$emit('haibaopopClose');
    },
    //选择需要生成海报的模块
    moduleCteate() {
      if (this.chooseList[0]?.select) {
        this.gaikuang = true;
      }
      if (this.chooseList[1]?.select) {
        this.datiliang = true;
      }
      if (this.chooseList[2]?.select) {
        this.zhengquelv = true;
      }
      if (this.chooseList[3]?.select || this.chooseList[4]?.select) {
        this.kaodianfenxi = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.loading {
  position: relative;
  width: 714px;
  height: 1100px;
  background: #fff;
  z-index: 1;
  padding-top:500px
}
#imageWrapper{
  position: absolute;
  left: -9999px;
}
.popup {
  background: none;
  border-radius: 36px !important;
}
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
::-webkit-scrollbar-thumb {
  // 添加 vertical ，单独设置垂直方向上的 滑块
  &:vertical {
    background-color: #fff;
  }
}
.sharePage {
  position: relative;
  width: 714px;
  height: 1100px;
  .posterBox {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 9999;
    .poster {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  .zhanwei {
    position: relative;
    width: 100%;
    height: 260px;
    // background-color: #33333354;
  }
  .weekBg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 676px;
    margin: 0 auto;
    z-index: 0;
    img {
      position: absolute;
      display: block;
      width: 100%;
    }
    .time {
      position: relative;
      font-size: 25px;
      font-weight: 400;
      color: #ffffff;
      padding-top: 160px;
      padding-bottom: 70px;
      padding-left: 56px;
    }
  }

  .qihang {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 678px;
    height: 168px;
    background: #f1f6ff;
    padding: 0 54px 0 45px;
    border-radius: 0 0 36px 36px;
    margin: -30px auto 0;
    .img1 {
      display: block;
      width: 220px;
      height: 66px;
    }
    .img2 {
      display: block;
      width: 120px;
      height: 120px;
      margin-top: 10px;
    }
  }
}
.onlytips {
  width: 460px;
  height: 60px;
  line-height: 60px;
  background-color: #ff7f41;
  border-radius: 20px;
  position: fixed;
  text-align: center;
  font-size: 24px;
  color: #fff;
  z-index: 9999;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
</style>
